import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=f1cfd46c&scoped=true&"
import script from "./Certifications.vue?vue&type=script&lang=js&"
export * from "./Certifications.vue?vue&type=script&lang=js&"
import style0 from "./Certifications.vue?vue&type=style&index=0&id=f1cfd46c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cfd46c",
  null
  
)

export default component.exports